import React, { useRef, useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useIsOverflow } from "./useIsOverflow";
import { Placement } from "react-bootstrap/esm/types";

type OverFlowToopTipProps = {
  text: string,
  className?: string,
  placement?: Placement,
  textSize?: string,
  lines?: "1" | "2" | "3",
}

const OverflowTooltip = (props: OverFlowToopTipProps) => {
  const lines = props.lines ?? "2";
  const placement = props.placement ?? "bottom-start";
  const ref = useRef<HTMLParagraphElement>(null);
  const isOverflow = useIsOverflow(ref);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  useEffect(() => {
    setTooltipVisible(isOverflow);
  }, [isOverflow]);

  const tooltip = tooltipVisible ? <Tooltip>{props.text}</Tooltip> : <></>;

  return <OverlayTrigger placement={placement} overlay={tooltip}>
    <p className={`line-clamp line-clamp-${lines} ${props.className}`} style={{ fontSize: props.textSize  }} ref={ref}>
      {props.text}
    </p>
  </OverlayTrigger>
}

export default OverflowTooltip;